import { environment } from '~app/environment';

import { findOrCreateWuid } from '@breeze/web-lib-wuid';

import type {
  ApplicationCreatedProperties,
  CalculatorOpenedProperties,
  PonApplicationBasicInfoNextClickProperties,
  PonApplicationBasicInfoViewProperties,
  PonApplicationBusinessDetailsNextClickProperties,
  PonApplicationBusinessDetailsViewProperties,
  PonApplicationContactReferenceNextClickProperties,
  PonApplicationContactReferenceViewProperties,
  PonApplicationCurrentAddressNextClickProperties,
  PonApplicationCurrentAddressViewProperties,
  PonApplicationEmploymentDetailsNextClickProperties,
  PonApplicationEmploymentDetailsViewProperties,
  PonApplicationEmploymentNextClickProperties,
  PonApplicationEmploymentViewProperties,
  PonApplicationFinancialInfoNextClickProperties,
  PonApplicationFinancialInfoViewProperties,
  PonApplicationHaveOutstandingDebtClickProperties,
  PonApplicationKycAdditionalIdNumberNextClickProperties,
  PonApplicationKycAdditionalIdNumberViewProperties,
  PonApplicationKycIdSelectionNextClickProperties,
  PonApplicationKycIdSelectionSecondaryNextClickProperties,
  PonApplicationKycIdSelectionViewProperties,
  PonApplicationKycMainIdNumberNextClickProperties,
  PonApplicationKycMainIdNumberViewProperties,
  PonApplicationKycNoPrimaryIdClickProperties,
  PonApplicationPermanentAddressDiffersFromCurrentClickProperties,
  PonApplicationPermanentAddressNextClickProperties,
  PonApplicationPermanentAddressViewProperties,
  PonApplicationPersonalDetailsNextClickProperties,
  PonApplicationPersonalDetailsViewProperties,
  PonBlockActiveApplicationViewProperties,
  PonBlockActiveLoanViewProperties,
  PonBlockCooldownViewProperties,
  PonBlockInvalidPhoneViewProperties,
  PonBlockOrderExpiredProperties,
  PonBlockSubmittedApplicationViewProperties,
  PonOtpConfirmationHaventReceivedCodeClickProperties,
  PonOtpConfirmationRequestNewCodeClickProperties,
  PonOtpConfirmationSuccessProperties,
  PonOtpConfirmationViewProperties,
  PonOtpConfirmationWrongCodeProperties,
  PonPhoneNumberGetCodeClickProperties,
  PonPhoneNumberViewProperties,
  PonRedirectToAppClickProperties,
  PonRedirectToAppViewProperties,
  PonScoringRejectedViewProperties,
  PonScoringRejectedWhyClickProperties,
  WebApplicationFinishedProperties,
} from '../../ampli';
import { ampli } from '../../ampli';

// Initialize ampli
ampli.load({
  client: {
    apiKey: environment.AMPLITUDE_ANALYTICS_KEY,
    configuration: {
      autocapture: false,
      appVersion: environment.APP_VERSION,
    },
  },
});
ampli.client.setUserId(findOrCreateWuid());

type EventPropsWithoutWuid<T> = Omit<T, 'wuid'>;
export const analytics = {
  track: {
    calculatorOpened: (
      props: EventPropsWithoutWuid<CalculatorOpenedProperties>
    ) => {
      ampli.calculatorOpened({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    applicationCreated: (
      props: EventPropsWithoutWuid<ApplicationCreatedProperties>
    ) => {
      ampli.applicationCreated({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    webApplicationFinished: (
      props: EventPropsWithoutWuid<WebApplicationFinishedProperties>
    ) => {
      ampli.webApplicationFinished({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationBasicInfoNextClick: (
      props: EventPropsWithoutWuid<PonApplicationBasicInfoNextClickProperties>
    ) => {
      ampli.ponApplicationBasicInfoNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationBasicInfoView: (
      props: EventPropsWithoutWuid<PonApplicationBasicInfoViewProperties>
    ) => {
      ampli.ponApplicationBasicInfoView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationBusinessDetailsNextClick: (
      props: EventPropsWithoutWuid<PonApplicationBusinessDetailsNextClickProperties>
    ) => {
      ampli.ponApplicationBusinessDetailsNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationBusinessDetailsView: (
      props: EventPropsWithoutWuid<PonApplicationBusinessDetailsViewProperties>
    ) => {
      ampli.ponApplicationBusinessDetailsView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationContactReferenceNextClick: (
      props: EventPropsWithoutWuid<PonApplicationContactReferenceNextClickProperties>
    ) => {
      ampli.ponApplicationContactReferenceNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationContactReferenceView: (
      props: EventPropsWithoutWuid<PonApplicationContactReferenceViewProperties>
    ) => {
      ampli.ponApplicationContactReferenceView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationCurrentAddressNextClick: (
      props: EventPropsWithoutWuid<PonApplicationCurrentAddressNextClickProperties>
    ) => {
      ampli.ponApplicationCurrentAddressNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationCurrentAddressView: (
      props: EventPropsWithoutWuid<PonApplicationCurrentAddressViewProperties>
    ) => {
      ampli.ponApplicationCurrentAddressView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationEmploymentDetailsNextClick: (
      props: EventPropsWithoutWuid<PonApplicationEmploymentDetailsNextClickProperties>
    ) => {
      ampli.ponApplicationEmploymentDetailsNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationEmploymentDetailsView: (
      props: EventPropsWithoutWuid<PonApplicationEmploymentDetailsViewProperties>
    ) => {
      ampli.ponApplicationEmploymentDetailsView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationEmploymentNextClick: (
      props: EventPropsWithoutWuid<PonApplicationEmploymentNextClickProperties>
    ) => {
      ampli.ponApplicationEmploymentNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationEmploymentView: (
      props: EventPropsWithoutWuid<PonApplicationEmploymentViewProperties>
    ) => {
      ampli.ponApplicationEmploymentView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationFinancialInfoNextClick: (
      props: EventPropsWithoutWuid<PonApplicationFinancialInfoNextClickProperties>
    ) => {
      ampli.ponApplicationFinancialInfoNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationFinancialInfoView: (
      props: EventPropsWithoutWuid<PonApplicationFinancialInfoViewProperties>
    ) => {
      ampli.ponApplicationFinancialInfoView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationHaveOutstandingDebtClick: (
      props: EventPropsWithoutWuid<PonApplicationHaveOutstandingDebtClickProperties>
    ) => {
      ampli.ponApplicationHaveOutstandingDebtClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationKycMainIdNumberView: (
      props: EventPropsWithoutWuid<PonApplicationKycMainIdNumberViewProperties>
    ) => {
      ampli.ponApplicationKycMainIdNumberView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationKycMainIdNumberNextClick: (
      props: EventPropsWithoutWuid<PonApplicationKycMainIdNumberNextClickProperties>
    ) => {
      ampli.ponApplicationKycMainIdNumberNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationKycAdditionalIdNumberNextClick: (
      props: EventPropsWithoutWuid<PonApplicationKycAdditionalIdNumberNextClickProperties>
    ) => {
      ampli.ponApplicationKycAdditionalIdNumberNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationKycAdditionalIdNumberView: (
      props: EventPropsWithoutWuid<PonApplicationKycAdditionalIdNumberViewProperties>
    ) => {
      ampli.ponApplicationKycAdditionalIdNumberView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationKycIdSelectionNextClick: (
      props: EventPropsWithoutWuid<PonApplicationKycIdSelectionNextClickProperties>
    ) => {
      ampli.ponApplicationKycIdSelectionNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationKycIdSelectionSecondaryNextClick: (
      props: EventPropsWithoutWuid<PonApplicationKycIdSelectionSecondaryNextClickProperties>
    ) => {
      ampli.ponApplicationKycIdSelectionSecondaryNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationKycIdSelectionView: (
      props: EventPropsWithoutWuid<PonApplicationKycIdSelectionViewProperties>
    ) => {
      ampli.ponApplicationKycIdSelectionView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationKycNoPrimaryIdClick: (
      props: EventPropsWithoutWuid<PonApplicationKycNoPrimaryIdClickProperties>
    ) => {
      ampli.ponApplicationKycNoPrimaryIdClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationPermanentAddressNextClick: (
      props: EventPropsWithoutWuid<PonApplicationPermanentAddressNextClickProperties>
    ) => {
      ampli.ponApplicationPermanentAddressNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationPermanentAddressDiffersFromCurrentClick: (
      props: EventPropsWithoutWuid<PonApplicationPermanentAddressDiffersFromCurrentClickProperties>
    ) => {
      ampli.ponApplicationPermanentAddressDiffersFromCurrentClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationPermanentAddressView: (
      props: EventPropsWithoutWuid<PonApplicationPermanentAddressViewProperties>
    ) => {
      ampli.ponApplicationPermanentAddressView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationPersonalDetailsNextClick: (
      props: EventPropsWithoutWuid<PonApplicationPersonalDetailsNextClickProperties>
    ) => {
      ampli.ponApplicationPersonalDetailsNextClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponApplicationPersonalDetailsView: (
      props: EventPropsWithoutWuid<PonApplicationPersonalDetailsViewProperties>
    ) => {
      ampli.ponApplicationPersonalDetailsView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponBlockActiveApplicationView: (
      props: EventPropsWithoutWuid<PonBlockActiveApplicationViewProperties>
    ) => {
      ampli.ponBlockActiveApplicationView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponBlockActiveLoanView: (
      props: EventPropsWithoutWuid<PonBlockActiveLoanViewProperties>
    ) => {
      ampli.ponBlockActiveLoanView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponBlockCooldownView: (
      props: EventPropsWithoutWuid<PonBlockCooldownViewProperties>
    ) => {
      ampli.ponBlockCooldownView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponBlockInvalidPhoneView: (
      props: EventPropsWithoutWuid<PonBlockInvalidPhoneViewProperties>
    ) => {
      ampli.ponBlockInvalidPhoneView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponBlockOrderExpired: (
      props: EventPropsWithoutWuid<PonBlockOrderExpiredProperties>
    ) => {
      ampli.ponBlockOrderExpired({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponBlockSubmittedApplicationView: (
      props: EventPropsWithoutWuid<PonBlockSubmittedApplicationViewProperties>
    ) => {
      ampli.ponBlockSubmittedApplicationView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponRedirectToAppClick: (
      props: EventPropsWithoutWuid<PonRedirectToAppClickProperties>
    ) => {
      ampli.ponRedirectToAppClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponRedirectToAppView: (
      props: EventPropsWithoutWuid<PonRedirectToAppViewProperties>
    ) => {
      ampli.ponRedirectToAppView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponScoringRejectedView: (
      props: EventPropsWithoutWuid<PonScoringRejectedViewProperties>
    ) => {
      ampli.ponScoringRejectedView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponScoringRejectedWhyClick: (
      props: EventPropsWithoutWuid<PonScoringRejectedWhyClickProperties>
    ) => {
      ampli.ponScoringRejectedWhyClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponOtpConfirmationHaventReceivedCodeClick: (
      props: EventPropsWithoutWuid<PonOtpConfirmationHaventReceivedCodeClickProperties>
    ) => {
      ampli.ponOtpConfirmationHaventReceivedCodeClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponOtpConfirmationRequestNewCodeClick: (
      props: EventPropsWithoutWuid<PonOtpConfirmationRequestNewCodeClickProperties>
    ) => {
      ampli.ponOtpConfirmationRequestNewCodeClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponOtpConfirmationSuccess: (
      props: EventPropsWithoutWuid<PonOtpConfirmationSuccessProperties>
    ) => {
      ampli.ponOtpConfirmationSuccess({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponOtpConfirmationView: (
      props: EventPropsWithoutWuid<PonOtpConfirmationViewProperties>
    ) => {
      ampli.ponOtpConfirmationView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponOtpConfirmationWrongCode: (
      props: EventPropsWithoutWuid<PonOtpConfirmationWrongCodeProperties>
    ) => {
      ampli.ponOtpConfirmationWrongCode({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponPhoneNumberGetCodeClick: (
      props: EventPropsWithoutWuid<PonPhoneNumberGetCodeClickProperties>
    ) => {
      ampli.ponPhoneNumberGetCodeClick({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
    ponPhoneNumberView: (
      props: EventPropsWithoutWuid<PonPhoneNumberViewProperties>
    ) => {
      ampli.ponPhoneNumberView({
        wuid: findOrCreateWuid(),
        ...props,
      });
    },
  },
};
